export const globalSearchModuleHeaderRowClassName =
  'flex w-full items-center justify-between gap-3 px-4 pb-1';

export const globalSearchModuleHeaderClassName =
  'm-0 min-w-0 flex-1 truncate text-sm leading-6 font-medium text-slate-400';
